<template>
  <comHeader></comHeader>
  <!-- inner banner -->
  <div class="inner-banner">
    <section class="w3l-breadcrumb">
      <div class="container">
        <h4 class="inner-text-title font-weight-bold text-white mb-sm-3 mb-2">
          联系我们
        </h4>
        <ul class="breadcrumbs-custom-path">
          <li><a href="/">主页</a></li>
          <li class="active">
            <span class="fa fa-chevron-right mx-2" aria-hidden="true"></span>
            联系我们
          </li>
        </ul>
      </div>
    </section>
  </div>
  <!-- //inner banner -->

  <!-- contact page -->
  <section class="w3l-contact-11 py-5" id="contact">
    <div class="container py-md-5 py-5">
      <div class="row justify-content-center text-center">
        <div class="col-md-8">
          <div class="section-heading mb-sm-5 mb-4">
            <h3 class="title-style mb-2">联系我们</h3>
            <p class="lead">
              有合作的火花？有产品点子的灵感？或是对我们尺码系统的小小建议？
              甚至只是想夸我们一下？
              不管哪种，我们都非常欢迎！请填写联系表，我们会第一时间联系您。
              或者，拨通我们的电话也是一个不错的选择。

            </p>
          </div>
        </div>
      </div>
      <div class="d-grid contact section-gap">
        <div class="contact-info-left d-grid text-center">
          <div class="contact-info">
            <span class="fa fa-map-marker" aria-hidden="true"></span>
            <h4>公司地址</h4>
            <p>
              Room 301, No.350 Nan Cheng Duan Guan Tai Road Nancheng Street,
              Dongguan City, Guangdong Province, China.
            </p>
          </div>
          <div class="contact-info">
            <span class="fa fa-phone" aria-hidden="true"></span>
            <h4>电话号码</h4>
            <p><a href="tel:+44 7834 857829">+85251420987</a></p>
          </div>
          <div class="contact-info">
            <span class="fa fa-envelope" aria-hidden="true"></span>
            <h4>邮箱地址</h4>
            <p>
              <a href="mailto:sunraymascotaofficial@gmail.com" class="email">sunraymascotaofficial@gmail.com</a
              >
            </p>
          </div>
          <div class="contact-info">
            <span class="fa fa-clock-o" aria-hidden="true"></span>
            <h4>营业时间</h4>
            <p>周一至周五：</p>
            <p>上午9:00 至下午 6:00</p>
          </div>
        </div>
      </div>
      <div class="form-41-mian mt-5 pt-lg-5 pt-md-4">
        <div class="container">
          <div class="form-inner-cont">
            <!-- 显示错误和成功消息 -->
            <div v-if="errorMessage" class="alert alert-danger mb-4" role="alert">
              <i class="fa fa-exclamation-triangle mr-2"></i>
              {{ errorMessage }}
            </div>
            
            <div v-if="successMessage" class="alert alert-success mb-4" role="alert">
              <i class="fa fa-check-circle mr-2"></i>
              {{ successMessage }}
            </div>
            
            <form class="signin-form" @submit.prevent="handleSubmit">
              <div class="row align-form-map">
                <div class="col-sm-6 form-input">
                  <label for="w3lName">姓名*</label>
                  <input
                    type="text"
                    name="name"
                    v-model="formData.name"
                    id="name"
                    required
                    placeholder=""
                  />
                </div>
                <div class="col-sm-6 form-input">
                  <label for="w3lSender">邮箱地址*</label>
                  <input
                    type="email"
                    name="email"
                    v-model="formData.email"
                    id="email"
                    placeholder=""
                    required=""
                  />
                </div>
                <div class="col-sm-6 form-input">
                  <label for="w3lSender">主题*</label>
                  <input
                    type="text"
                    name="subject"
                    id="subject"
                    v-model="formData.subject"
                    required=""
                    placeholder=""
                    class="contact-input"
                  />
                </div>
                <div class="col-sm-6 form-input">
                  <label for="w3lSender">联系电话*</label>
                  <input
                    type="text"
                    name="phoneNum"
                    v-model="formData.phoneNum"
                    id="phoneNum"
                    placeholder=""
                    required=""
                    class="contact-input"
                  />
                </div>
              </div>
              <div class="form-input">
                <label for="w3lMessage">留言*</label>
                <textarea
                  placeholder=""
                  name="message"
                  v-model="formData.message"
                  id="message"
                  required=""
                ></textarea>
              </div>
              <div class="submit text-right">
                <button
                  type="submit"
                  class="btn btn-style-white btn-style-primary"
                  :disabled="isLoading"
                >
                  <span v-if="isLoading">
                    <i class="fa fa-spinner fa-spin mr-2"></i>
                    提交中...
                  </span>
                  <span v-else>
                    提交
                  </span>
                </button>
              </div>
            </form>
          </div>
          <!-- <div class="map mt-5">
            <iframe
              src="https://www.amap.com/"
              frameborder="0"
              style="border: 0"
              allowfullscreen
            ></iframe>
          </div> -->
        </div>
      </div>
    </div>
  </section>
  <!-- //contact page -->
</template>

<script setup>
import { ref } from "vue";
import { api, utils } from "../assets/js/requests.js";
import comHeader from "../components/comHeader.vue";

const formData = ref({
  name: "",
  email: "",
  phoneNum: "",
  subject: "",
  country: "",
  message: "",
});
const errorMessage = ref("");
const successMessage = ref("");
const isLoading = ref(false);

const handleSubmit = async () => {
  // 清空之前的消息
  errorMessage.value = "";
  successMessage.value = "";
  
  // 表单验证
  if (!formData.value.name.trim()) {
    errorMessage.value = "Please enter your name";
    return;
  }
  
  if (!formData.value.email.trim()) {
    errorMessage.value = "Please enter your email";
    return;
  }
  
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.value.email)) {
    errorMessage.value = "Please enter a valid email address";
    return;
  }
  
  if (!formData.value.subject.trim()) {
    errorMessage.value = "Please enter a subject";
    return;
  }
  
  if (!formData.value.message.trim()) {
    errorMessage.value = "Please enter your message";
    return;
  }

  try {
    isLoading.value = true;
    
    const response = await api.contact.submitMessage(formData.value);
    console.log("Form submitted successfully:", response);
    
    successMessage.value = "Message submitted successfully! We'll get back to you soon.";
    
    // 清空表单
    formData.value = {
      name: "",
      email: "",
      phoneNum: "",
      subject: "",
      country: "",
      message: "",
    };
    
  } catch (error) {
    console.error("Form submission error:", error);
    errorMessage.value = utils.formatError(error) || "Failed to submit message. Please try again.";
  } finally {
    isLoading.value = false;
  }
};
</script>
<script>
export default {
  name: "appContact",
};
</script>
<style scoped>
/* 警告和成功消息样式 */
.alert {
  padding: 12px 20px;
  border-radius: 6px;
  border: 1px solid transparent;
  font-size: 14px;
  line-height: 1.5;
}

.alert-danger {
  background-color: #f8d7da;
  border-color: #f5c6cb;
  color: #721c24;
}

.alert-success {
  background-color: #d4edda;
  border-color: #c3e6cb;
  color: #155724;
}

/* 提交按钮加载状态 */
.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.fa-spin {
  animation: fa-spin 2s infinite linear;
}

@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(359deg);
  }
}

/* 表单验证样式 */
.form-input input.error,
.form-input textarea.error {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

.form-input input:focus,
.form-input textarea:focus {
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

/* 响应式优化 */
@media (max-width: 768px) {
  .alert {
    font-size: 13px;
    padding: 10px 15px;
  }
}
</style>
